<template>
  <div>
    <!-- Base Modal Window -->
    <modal
      name="default"
      @before-open="initParams($event, { body: 'modal-is-open' })"
      @closed="clear"
      :height="options.height"
      width="50%"
    >
      <div class="ev-digital-event-modal-window">
        <div class="header">
          <a href="javascript:void(0);" class="pull-right close-modal" @click="close"
            ><i class="fa fa-lg fa-times"></i
          ></a>
          <div class="title">{{ context.title }}</div>
        </div>
        <div class="body">
          {{ context.body }}
        </div>
        <div class="footer">
          <button type="button" class="btn btn-primary pull-right" @click="close">
            {{ context.closeText || "Close" }}
          </button>
        </div>
      </div>
    </modal>

    <!-- Modal Window with Iframe -->
    <modal
      name="iframe-modal-window"
      @before-open="initParams($event, { body: 'modal-is-open' })"
      @closed="clear"
      height="80%"
      width="80%"
    >
      <div class="ev-digital-event-modal-window">
        <div class="header">
          <a href="javascript:void(0);" class="pull-right close-modal" @click="close"
            ><i class="fa fa-lg fa-times"></i
          ></a>
          <div class="title">{{ context.title }}</div>
        </div>
        <div class="body">
          <digital-event-preloader type="container" :active="isLocalLoading"></digital-event-preloader>
          <iframe :src="context.url" class="modal-iframe" style="border: 0;" @load="load"></iframe>
        </div>
        <div class="footer">
          <button type="button" class="btn btn-primary pull-right" @click="close">
            {{ context.closeText || "Close" }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
/**
 * This component contains ModalWindow templates
 */
import Preloader from "@/components/DigitalEvent/common/Preloader";
import CommonMixin from "@/components/DigitalEvent/mixins/CommonMixin";

export default {
  name: "ModalWindow",
  mixins: [CommonMixin],
  components: {
    "digital-event-preloader": Preloader
  },
  data() {
    return {
      name: "default",
      context: {},
      options: {},
      styleSettings: {},
      isLocalLoading: false
    };
  },
  methods: {
    /**
     * Init Modal Window params
     * Set custom DOM styles
     * @param event
     * @param styleSettings
     */
    initParams(event, styleSettings) {
      let { name, context, options } = event.params;
      this.name = name;
      this.context = context;
      this.options = options;
      this.styleSettings = styleSettings;

      Object.entries(this.styleSettings).forEach(data => {
        window.document.querySelector(data[0]).classList.add(data[1]);
      });

      this.isLocalLoading = true;
    },

    /**
     * Remove DOM styles
     */
    clear() {
      Object.entries(this.styleSettings).forEach(data => {
        window.document.querySelector(data[0]).classList.remove(data[1]);
      });
    },

    /**
     * Close Modal Window
     */
    close() {
      this.$modal.hide(this.name);
    },

    /**
     * Loading is finished (at the time it's used for the iframe)
     */
    load() {
      this.isLocalLoading = false;
    }
  }
};
</script>
